<template>
    <div class="resource__preview">
        <div class="resource__title">
            <a
                v-if="resource.posted_via === 'Slack'"
                :href="resource.canonical_url"
                target="_blank"
                v-on:click="linkClickCheck"
                rel="noopener noreferrer">
                <span
                  v-html="resource.title"
                  v-bind:contenteditable="isEdit"
                  v-on:blur="updateResourceTitle"
                  ></span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
            </a>
            <a
                v-if="resource.posted_via !== 'Slack'"
                :href="resource.pdf_url"
                target="_blank"
                v-on:click="linkClickCheck">
                <span
                  v-html="resource.title"
                  v-bind:contenteditable="isEdit"
                  v-on:blur="updateResourceTitle"
                  ></span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
            </a>
        </div>

        <cite class="resource__cite">
            <a
                :href="resource.provider_url"
                rel="noopener noreferrer"
                class="has-text-grey">
                <figure class="image is-16x16 resource__favicon">
                    <img
                        :src="resource.favicon_url"
                        referrerpolicy="no-referrer"
                        :alt="resource.provider_name"
                    >
                </figure>
                <span class="resource__source">{{ resource.provider_display }}</span>
            </a>
            <time-stamp class="resource__publishedAt" :datetime="resource.published_at" />
            <a
                class="resource__permalink"
                :href="'/resource/' + resource.id">
                permalink
            </a>
        </cite>
        <div v-if="resource.thumbnail_url" class="media">
            <figure class="media-left">
                <p class="image is-64x64">
                    <img
                        :src="resource.thumbnail_url"
                        referrerpolicy="no-referrer"
                        alt="image preview"
                    >
                </p>
            </figure>
            <div v-if="resource.description" class="media-content">
                <div class="content" v-html="resource.description"></div>
            </div>
        </div>
    </div>
</template>

<script>

import TimeStamp from './TimeStamp';

export default {
    props: {
        resource: {
            type: Object
        },
        isEdit: Boolean
    },

    components: {
        'time-stamp': TimeStamp
    },
    methods: {
      linkClickCheck(e) {
        if (this.isEdit) {
          e.stopPropagation();
          e.preventDefault();
          return false;
        }
        return true;
      },
      updateResourceTitle(e) {
        this.resource.title = e.target.innerText;
      }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LinkPreview.vue